// DashboardLayout opens UserAccountModal over this route — render a neutral
// loading state so nothing flashes before the modal opens.
const Account = () => (
    <div className="flex items-center justify-center py-20">
        <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500" />
    </div>
);

export default Account;
